import { render, staticRenderFns } from "./RoomTestbankHistoryListTable.vue?vue&type=template&id=59b1965d&scoped=true&"
import script from "./RoomTestbankHistoryListTable.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankHistoryListTable.vue?vue&type=script&lang=js&"
import style0 from "./RoomTestbankHistoryListTable.vue?vue&type=style&index=0&id=59b1965d&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b1965d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b1965d')) {
      api.createRecord('59b1965d', component.options)
    } else {
      api.reload('59b1965d', component.options)
    }
    module.hot.accept("./RoomTestbankHistoryListTable.vue?vue&type=template&id=59b1965d&scoped=true&", function () {
      api.rerender('59b1965d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/History/RoomTestbankHistoryListTable.vue"
export default component.exports